import beTwMerge from '@/utils/beTwMerge';
import ResponsiveImage, { ResponsiveImageSet } from '@/utils/ResponsiveImage';

interface BirthstoneProps {
  anchor: string;
  month: string;
  name: string;
  imageSrcs: ResponsiveImageSet;
  altText?: string;
}

export interface BirthstoneCarouselProps {
  optionalHeader?: string;
  titleTag?: 'h1' | 'h2' | 'h3' | 'h4';
  items: BirthstoneProps[];
  className?: string;
}

function Birthstone({ anchor, month, name, imageSrcs, altText }) {
  const animateScroll = (targetId: string) => {
    const targetElement = document.getElementById(targetId);
    const yOffset = -50;
    if (targetElement) {
      const y = targetElement.getBoundingClientRect().top + window.scrollY + yOffset;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  };

  return (
    <li className="tw-tracking-wide tw-leading-[1.2] tw-text-xs tw-text-center tw-flex-[1_0_64px] md:tw-flex-[0_0_13.3%] lg:tw-flex-[1_0_64px] tw-mb-[10px] tw-scroll-snap-align-start">
      <button
        type="button"
        className="tw-bg-transparent tw-border-none tw-cursor-pointer tw-m-0 tw-p-0 tw-text-color-black"
        onClick={() => animateScroll(anchor)}
        data-label={`Birthstone|Choose Birthstone|${month} ${name}`}
      >
        <div className="slideImgContainer">
          <ResponsiveImage
            className="tw-block tw-mx-[auto] tw-my-[0] tw-rounded-[100%] tw-object-contain tw-w-[30px] tw-h-[30px] tw-mb-[10px]"
            sources={imageSrcs}
            alt={altText || name}
          />
        </div>
        <div>{month}</div>
        <div>{name}</div>
      </button>
    </li>
  );
}

export default function BirthstoneCarousel({
  optionalHeader,
  titleTag = 'h2',
  items = [],
  className,
}: BirthstoneCarouselProps) {
  const TitleTag = titleTag;

  return (
    <div
      className={beTwMerge(
        `tw-mx-auto tw-relative lg:tw-w-[1030px] min-[1440px]:tw-h-full min-[1440px]:tw-block`,
        className
      )}
    >
      {optionalHeader && (
        <div className="tw-text-center tw-inline-block tw-w-full tw-mb-10 md:tw-mb-8 tw-px-4 md:tw-px-0">
          <TitleTag className="tw-text-center tw-font-normal tw-mb-0 tw-break-words">{optionalHeader}</TitleTag>
        </div>
      )}
      <ul
        style={{ touchAction: 'pan-x' }}
        className="tw-px-4 md:tw-px-0 md:tw--mx-[9px] lg:tw-mx-0 tw-mt-0 tw-mb-0 md:tw-justify-start lg:tw-justify-center tw-transition-[left] tw-duration-[0.25s] tw-ease-[ease] tw-list-none tw-scroll-pl-2.5 tw-flex tw-flex-row tw-w-full tw-justify-between tw-overflow-x-scroll lg:tw-overflow-x-hidden [scroll-snap-type:x_proximity] stones-list"
      >
        {items?.map((item: BirthstoneProps, index: number) => (
          <Birthstone
            key={index}
            anchor={item.anchor}
            month={item.month}
            name={item.name}
            imageSrcs={item.imageSrcs}
            altText={item.altText}
          />
        ))}
      </ul>
    </div>
  );
}
